module.exports = __webpack_public_path__ + "static/media/Item 27.f85d53d6.jpg";